import { observer } from "mobx-react-lite";
import {
  Box,
  Center,
  ChakraProps,
  Spinner,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from "@chakra-ui/react";

import { useSelecting, langStore, translate, useIsReady, toolbarStore } from "@noli/business";

import { RIGHT_WIDTHS } from "@/utils/constants";
import { themeStore } from "@/stores/theme";
import UploaderPanel from "./UploaderPanel";
import UtilsPanel from "./UtilsPanel";
import IntroPanel from "./IntroPanel";
import NodeEditor from "@/modules/editor/NodeEditor";
import ContactUs from "@/modules/editor/components/ContactUs";
import PostWork from "../../components/Post";
import React from "react";
import { Editor_Words } from "@/utils/lang/editor";
import { InspirationPanel } from "./Inspiration";
import { setRightPanelTab, uiStore } from "@/stores/ui";

const TAB_BARS_HEIGHT = "42px";
const tabBarStyle: ChakraProps = {
  color: "#ccc",
  bg: "#404040",
  border: "none",
  borderTopLeftRadius: "4px",
  borderTopRightRadius: "4px",
  fontSize: "14px",
  fontWeight: 500,
  mb: "0px",
  _selected: { color: "#2bfbc6", bg: "#323232" },
  boxShadow: "0px -4px 4px rgba(0, 0, 0, 0.25)",
};

const RightPanel: React.FC = () => {
  const { panelBg } = themeStore.styles;
  const { type } = useSelecting("raw");
  const { rightPanelTab } = uiStore;

  return (
    <Box w={RIGHT_WIDTHS} h="100%" bg={panelBg}>
      <Tabs
        index={rightPanelTab}
        onChange={setRightPanelTab}
        isFitted
        variant="enclosed"
        h="100%"
        display="flex"
        flexDirection="column"
      >
        <TabList h={TAB_BARS_HEIGHT} bg="#404040" borderBottom="none" paddingTop="0px" px="0px">
          <Tab {...tabBarStyle}>
            {translate(Editor_Words["right-panel-tab-operations"], langStore.tgt)}
          </Tab>
          <Tab {...tabBarStyle}>
            {translate(Editor_Words["right-panel-tab-inspiration"], langStore.tgt)}
          </Tab>
        </TabList>
        <TabPanels h={`calc(100% - ${TAB_BARS_HEIGHT})`}>
          <TabPanel h="100%" p="0" pos="relative" pb="60px" display="flex" flexDir="column">
            {!useIsReady() ? (
              <Center pt="100px">
                <Spinner color="gray.400" size="md" />
              </Center>
            ) : (
              <>
                <UploaderPanel />
                <UtilsPanel />
                {type === "none" && !toolbarStore.inBrushMode ? (
                  <Center w="100%" px="10%" mb="24px">
                    <PostWork buttonType="outline" />
                  </Center>
                ) : null}
                <IntroPanel />
                <NodeEditor />
                <ContactUs />
              </>
            )}
          </TabPanel>
          <TabPanel h="100%" p="0" pt="14px">
            <InspirationPanel />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default observer(RightPanel);
